export const nomeArquivoContentDisposition = (content: string): string => {
  const nomeArquivo = content
    .split(';')
    .find((valor: string) => valor.includes('filename'))

  return nomeArquivo.slice(nomeArquivo.indexOf('=') + 1, nomeArquivo.length)
}
